import { LOCALES } from '../locales';

export default {
    [LOCALES.RUSSIAN]: {
        'cookieBannerLabel': 'Уведомление о файлах cookie',
        'cookieBannerIntro': 'Мы используем файлы cookie. Они помогают улучшать сайт и делать его удобнее.',
        'cookieBannerConsent': 'Нажимая «Принять», вы соглашаетесь с их использованием и передачей данных сервису веб-аналитики Яндекс Метрика. Если нет — измените настройки браузера или покиньте сайт.',
        'cookieBannerAccept': 'Принять',
        'cookieBannerDetails': 'Подробнее',
        'headerTitle': 'Всё, что нужно для эффективной оценки заемщиков',
        'whatIs':'Что такое ',
        'axiLink': 'AxiLink',
        'axiDecision': 'AxiDecision',
        'axiDecisionFullName':'Система поддержки принятия решений',
        'axiDecisionName':'AxiDecision',
        'axiDecisionDescMain': `Программное обеспечение «Система поддержки принятия решений AxiDecision» позволяет осуществлять процесс разработки,
         тестирования и управления стратегией принятия решения и бизнес-правилами.`,
        'axiDecisionDesc':'Функциональные характеристики ПО',
        'fn_check': `Создание и модификация логических проверок в рамках бизнес-процессов при оценке кредитоспособности, возможного мошенничества,
            валидации и андеррайтинга в банковских, страховых и иных финансовых институтах;`,
        'fn_gui': 'Поддержка графического интерфейса и предустановленных визуальных компонент системы для возможности настройки и модификации;',
        'fn_audit': 'Проведение аудита и протоколирование действий пользователя;',
        'fn_development': 'Возможность вести разработку несколькими пользователями;',
        'fn_permissions': 'Осуществление контроля доступа пользователей и разграничения физически сред разработки, тестирования и "боевой" эксплуатации;',
        'fn_customization': 'Возможность создавать собственные агрегаты, функции и сценарии обработки посредством адаптивного языка;',
        'fn_integrity': 'Контроль целостности сборки и сокращения доли ошибок реализации настроек системы посредством механизма check-in/check-out и версионирования компонент;',
        'fn_models': 'Доступность использования широкого спектра скоринговых моделей как интерпретируемых, так и не-/слабо- интерпретируемых в формате PMML.',
        'manageRequests': `Благодаря широким возможностям программное обеспечение «Система поддержки принятия решений AxiDecision» позволяет перенести всю логику
         принятия решений риск-менеджера в стратегию и заложить алгоритм, на основе которого осуществляется процесс обработки заявок.`,
        'advantages': 'Основные преимущества ПО "Система поддержки принятия решений AxiDecision"',
        'experience': `Успешный опыт нашей команды по внедрению аналогичных систем оценки кредитных заявок от вендоров FICO и
            Experian в розничном кредитовании для банков, МФО и страховых.`,
        'lowCost': '<b>Отсутствие</b> капительных <b>затрат</b>;',
        'lowCode': '<b>Low-Code</b> для сокращения времени включения сотрудников риск-департамента в процесс разработки стратегий оценки;',
        'presets': 'Наличие <b>преднастроенных, универсальных объектов</b> системы;',
        'fastIntegration': '<b>Высокая скорость</b> внедрения;',
        'supportCostReduction': '<b>Сокращение затрат</b> на поддержку решения;',
        'questionMark':'?',
        'month':'мес',
        'connectionRequest':'Стоимость программного обеспечения рассчитывается индивидуально',
        'priceTitle':'Стоимость ПО',
        'service':'Обслуживание',
        'orderDemo': 'заказать демо',
        'getDemo': 'получить демо',
        'send': 'Отправить',
        'product': 'продукт',
        'companyName':'Аксиоматика',
        'tariffs':'Тарифы',
        'purchaseService':'По вопросам приобретения ПО',
        'company':'Компания',
        'jobs':'Вакансии',
        'contacts':'Контакты',
        'integrations':'Интеграции',
        'developers':'Разработчикам',
        'axiomatika': 'axiomatika',
        'about':'О ',
        'formText': '<b>Система поддержки принятия решений AxiDecision</b> — эффективное промышленное решение!',
        'fullName': 'Имя',
        'email': 'Email',
        'phoneNumber': 'Номер телефона',
        'message': 'Сообщение',
        'documentation': 'Документация',
        'supportService': 'Служба технической поддержки',
        'supportPhoneNumber': 'Телефон',
        'usersGuide': 'Инструкция пользователя',
        'installationInstructions': 'Инструкция по установке',
        'lifeCycleProcessesDescription': 'Описание процессов жизненного цикла',
        'fCompanyName': 'ООО «Аксиоматика»',
        'fCompanyAddress': '127006, г. Москва, пер Успенский, д. 3, стр. 4',
        'fCompanyVlgAddress': '400074, г. Волгоград, ул. Баррикадная 1 Б',
        'fCompanyINN': 'ИНН 7703717147',
        'fPhone': 'телефон',
        'fStack': 'Технологический стек',

        'fOKVED': 'ОКВЭД 63.11.1',
        'fActivityType': 'Вид деятельности в области информационных технологий Программы для ЭВМ AxiDecision 11.05',
        'fDeveloperText': 'Разработчиком и правообладателем Программ для ЭВМ AxiDecision является',
        'fDeveloperName': 'ООО «Аксиоматика»',
        'fCertificate': 'Свидетельство о государственной регистрации программы для ЭВМ AxiDecision №2024660454 от «07» мая 2024г.',
        'fRegistryRecord': 'Реестровая запись в Едином реестре российского программного обеспечения №24746 от 15.11.2024',

        'fSubmitButtonAgree': 'Я даю согласие на',
        'fConsentAnd': 'и ознакомлен(а) с',
        'fPersonalData': 'обработку персональных данных',
        'fPrivacyPolicy': 'Политикой конфиденциальности',
        'fLaborEvaluation': 'Материалы специальной оценки труда',

        'connectionCost': 'Стоимость программного обеспечения',
        'connectionCostInd': 'Рассчитывается индивидуально',
        'connectionAndService': 'Стоимость Программы для ЭВМ AxiDecision',
        'connectionAndServiceCostInd': 'Стоимость лицензионного вознаграждения Программы для ЭВМ предоставляется индивидуально по запросу',
        'connectionAndServiceCostMonthly': 'ПО AxiDecision от 80 000 рублей в месяц. Итоговая стоимость зависит от количества заявок',
        'onPremise': 'Права на Программу ЭВМ AxiDecision предоставляются как простая (неисключительная лицензия) по нескольким моделям',
        'onPremise1': 'on-premise, ПО устанавливается на инфраструктуру Лицензиата',
        'onPremise2': 'веб-доступ, ПО размещено в контуре Лицензиара',

        'aboutCompany': 'О Компании',
        'companyInfo': 'Компания «Аксиоматика» основана в 2012 году. Мы специализируемся на сервисах по оценке заемщиков для банков и микрофинансовых организаций. Мы предлагаем своим клиентам самые передовые технологии и обширный спектр решений и услуг.',
        'companyMission': 'Наша миссия – делать лучшее доступным при помощи мировых IT-решений и практик для финансовых организаций',
        'companyExperience': 'Наша компания накопила огромный опыт в области разработки, внедрения решений и оказания услуг для банков и микрофинансовых организаций. Мы с удовольствием поделимся нашим опытом с Вами'
    }
};
